import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const logo = css`
  transition: transform 0.25s ease-in;
`;

export const root = css`
  display: flex;
  gap: 1rem;
  flex: 1;
  align-items: center;
  border-radius: 0.5rem;
  font-size: 16px;
  @media screen and (width > ${theme.sizes.screens.sm}) {
  }

  &:hover .${logo} {
    @media screen and (width > ${theme.sizes.screens.sm}) {
      transform: scale(1.1);
    }
  }
`;

export const vertical = css`
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: calc(var(--size) + 25px);
`;

export const info = css`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-width: 100%;
`;

export const title = css`
  font-weight: 700;
  font-size: 1.1em;
`;

export const subtitle = css`
  display: flex;
  gap: 0.25rem;
  font-weight: 500;
  color: ${theme.colors.peoople['gris-oscuro']};
`;

export const count = css`
  color: ${theme.colors.peoople['gris-medio-claro']};
  font-weight: 500;
  font-size: 0.9em;
`;
